import { render, staticRenderFns } from "./Telefonos.vue?vue&type=template&id=9d5f3e02&scoped=true&"
import script from "./Telefonos.vue?vue&type=script&lang=ts&"
export * from "./Telefonos.vue?vue&type=script&lang=ts&"
import style0 from "./Telefonos.vue?vue&type=style&index=0&id=9d5f3e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5f3e02",
  null
  
)

export default component.exports